import Heading from "components/global/Heading"
import Netflix from 'assets/images/netflix.png';
import Mschf from 'assets/images/mschf.png';
import Duolingo from 'assets/images/duolingo.png';
import Picsart from 'assets/images/picsart.png';
import Pg from 'assets/images/pg.png';

const clients = [Netflix , Picsart , Duolingo , Pg , Netflix , Mschf , ]

const Clients = () => {
    return (
        <div className="w-full  py-12 md:px-28 sm:px-12 px-4">
            <div>
                <Heading 
                title='Clients' 
                subTitle='Some of our clients who think we’re pretty cool' 
                />
            </div>
            <div className="grid lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-6 mt-12">
                {
                    clients?.map((client,i) => (
                        <div 
                        className="w-full px-12 py-6 rounded-md border border-primaryLight flex items-center justify-center"
                        key={i}
                        >
                            <img 
                            src={client} 
                            alt="client"
                            className="w-[150px]" 
                            />
                        </div>
                    ))
                }
            </div>
        </div>
    )
}

export default Clients